import styled from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 24px;
  text-align: center;
`;

export const Icon = styled.div`
  color: ${tokens.color.textAsh};
  font-size: 2.5rem;
  margin-bottom: 8px;
`;

export const Title = styled.h2`
  color: ${tokens.color.textWhite};
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
`;

export const Description = styled.p`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.body.size};
  margin: 0;
  max-width: 40ch;
`;

export const ActionSlot = styled.div`
  margin-top: 8px;
`;
